import { Box, CardContent, makeStyles, Typography, useTheme } from '@material-ui/core'
import React from 'react'
import { styles } from './emptyCard.styles'

export interface EmptyContentProps {
  title?: string
}

export const EmptyContent: React.FC<EmptyContentProps> = ({ title = '', children }) => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  return (
    <CardContent className={classes.cardContent}>
      <Box margin="auto" mt={1} mb={1}>
        <Typography variant="subtitle1">{title}</Typography>
      </Box>
      <Box margin="auto" mb={title ? 4 : 0}>
        {children}
      </Box>
    </CardContent>
  )
}
